/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import ServicePath from "@/core/ServicePath"
import {
    MainRequest
} from "@/core/request";

export default class PharmacyPrescriptionRequest extends MainRequest {

    static addPharmacyPrescription(data){
        return this.postSEC(ServicePath.PHARMACY_PRESCRIPTION_ADD, data);
    }

    static listAllPharmacyPrescription(){
        return this.getSEC(ServicePath.PHARMACY_PRESCRIPTION_LIST_ALL)
    }

    static updatePharmacyPrescription(data){
        return this.postSEC(ServicePath.PHARMACY_PRESCRIPTION_UPDATE, data)
    }

    static deletePharmacyPrescription(data){
        return this.postSEC(ServicePath.PHARMACY_PRESCRIPTION_DELETE, data)
    }

    static listPharmacyPrescriptionByPrescription(data){
        return this.postSEC(ServicePath.PHARMACY_PRESCRIPTION_LIST_ALL_BY_PRESCRIPTION, data)
    }

}